<div class="modal-content edit-phone-modal">
    <div class="modal-header">
        <h2 class="title-modal">{{ modal?.title }}</h2>
        <lsq-button
            *ngIf="!this.isSubmitting"
            appearance="transparent"
            class="close"
            ariaLabel="Close"
            (buttonClick)="modalService.closeModal()"
        >
            <lsq-icon aria-hidden="true" [type]="icons.Close" [color]="color.Black"> </lsq-icon>
        </lsq-button>
    </div>
    <div class="modal-body" *ngIf="this.isSubmitting">
        <lsq-circle-loader></lsq-circle-loader>
    </div>
    <div class="modal-body" *ngIf="!this.isSubmitting">
        <form [formGroup]="formGroup">
            <span class="subtitle-modal">{{ this.edit_phone_subtitle }}</span>
            <lsq-input
                formControlName="phoneNumber"
                name="phoneNumber"
                label="Mobile Phone Number *"
                [mask]="phoneMask"
                [unmask]="phoneUnmask"
                [group]="formGroup"
            >
            </lsq-input>
            <div class="modal-footer">
                <div class="modal-footer-left">
                    <lsq-button
                        appearance="secondary"
                        (buttonClick)="modalService.closeModal()"
                        class="cancel-btn pull-left"
                    >
                        Cancel
                    </lsq-button>
                </div>
                <div class="modal-footer-right">
                    <lsq-button
                        appearance="primary"
                        class="confirm-btn"
                        [size]="'lg'"
                        (buttonClick)="confirmModal()"
                        [disabled]="!this.formGroup.valid"
                    >
                        Save
                    </lsq-button>
                </div>
            </div>
        </form>
    </div>
</div>
